module.exports = __webpack_public_path__ + "static/media/dim-star.b4dfe0ee.svg";